import NumberFlow from "@number-flow/react";
import { Box, SxProps, Theme } from "@mui/material";

interface TimeUnitProps {
  value: number;
  sx?: SxProps<Theme>;
}

interface CountdownClockProps {
  seconds: number;
  className?: string;
  sx?: SxProps<Theme>;
}

export const TimeUnit = ({ value, sx }: TimeUnitProps) => (
  <Box component="span" sx={sx}>
    <NumberFlow
      value={Math.max(0, value)}
      format={{ minimumIntegerDigits: 2 }}
      trend={-1}
    />
  </Box>
);

const CountdownClock = ({ seconds, className, sx }: CountdownClockProps) => {
  const safe = Math.max(0, seconds);

  return (
    <Box className={className} sx={{ display: "inline-flex", alignItems: "baseline", ...sx }}>
      <TimeUnit value={Math.floor(safe / 60)} />
      <Box component="span">:</Box>
      <TimeUnit value={safe % 60} />
    </Box>
  );
};

export default CountdownClock;
